module.exports = __webpack_public_path__ + "static/media/man_working_laptop.2013a33e.png";